module.exports = __webpack_public_path__ + "img/005.877fe83c.svg";